<template>
<div class="app has-header">
    <div class="header main">
        <div class="align-left"></div>
        <div class="align-middle">
            <headerbuttonstack :state="headerButtons"/>
        </div>
        <div class="align-right">
            <headerbuttonstack :state="sideButtons"/>
        </div>
    </div>
    <div class="scrollbar-container">
        <div class="page-settings data-input">
            <div class="content">
                <div class="full">
                    <div class="mainheader">
                        <div class="half">
                            {{ $t('store.templates.title') }}
                        </div>
                    </div>
                </div>
                <div class="full">
                    <div class="label" style="text-align: left;">
                        {{ $t('store.templates.help') }}
                    </div>
                </div>
                <div class="full-min split-flat thick">&nbsp;</div>
            </div>
            <storeplanningguidelinesemployeerules ref="compemployeerulestemplate" @update-loading-state="updateLoadingState"></storeplanningguidelinesemployeerules>
            <div class="full-min split-flat thick">&nbsp;</div>
            <storeplanningguidelinesemployeetype :displayInactiveConctractTemplates="displayInactiveConctractTemplates" ref="compemployeetypetemplate" @update-loading-state="updateLoadingState"></storeplanningguidelinesemployeetype>
            <div class="full">&nbsp;</div>
            <div class="full">&nbsp;</div>
            <div class="full">&nbsp;</div>
            <div class="full">&nbsp;</div>
        </div>
    </div>
    <div v-if="loadingState > 0" class="loading-md bg">
        <i class="fas fa-spinner"></i>
        <br/>
        <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
            {{ loadingText }}
        </div>
    </div>
</div>
</template>

<script>
import storeplanningguidelinesemployeerules from './StorePlanningGuidelinesEmployeeRules.vue'
import storeplanningguidelinesemployeetype from './StorePlanningGuidelinesEmployeeType.vue'

export default {
    components: {
        storeplanningguidelinesemployeerules,
        storeplanningguidelinesemployeetype
    },
    name: 'storeplanningguidelines',
    data() {
        return {
            loadingState: 0,
            loadingText: this.$t('workBalance.averages.loading'),
            displayInactiveConctractTemplates: false,
        }
    },
    created: function () {},
    // methods that implement data logic.
    methods: {
        refresh(){
            this.$refs.compemployeetypetemplate.refresh();
            this.$refs.compemployeerulestemplate.refresh();
        },
        OpenMenuDetails($event, state) {

            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: state,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        updateLoadingState(state){
            if(state){
                this.loadingState++;
            }else{
                this.loadingState--;
            }
        }
    },
    computed: {
        storeId() {
            return this.$store.state.storeId;
        },
        headerButtons() {
            let helperLinks = [];
            let buttons = [
                {
                    classes: "add-employeerulestemplate",
                    type: "block green border-r",
                    disabled: false,
                    icon: "fa-couch",
                    click: ($event) => { 
                        this.$refs.compemployeerulestemplate.openCreatePopup($event);
                        },
                    show:  true,
                    tooltip: this.$t('store.templates.addLeisureTemplate'),
                    title: this.$t('store.templates.addLeisureTemplate'),
                    helperText: this.$t('store.templates.addLeisureTemplateHelp'),
                    //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                },
                {
                    classes: "add-plantypetemplate",
                    type: "block green",
                    disabled: false,
                    icon: "fa-ruler-combined",
                    click: ($event) => { 
                        this.$refs.compemployeetypetemplate.openCreatePopup($event);
                        },
                    show:  true,
                    tooltip: this.$t('store.templates.addPlanTypeTemplate'),
                    title: this.$t('store.templates.addPlanTypeTemplate'),
                    helperText: this.$t('store.templates.addPlanTypeTemplateHelp'),
                    //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                }
            ];
            let state= {
                buttons: buttons,
                helperLinks: helperLinks,
                showListIconAlways: true
                };

            state.helperLinks = [
            {
                icon: "fa-video",
                title: this.$t('store.structure.watchTrainingVideo'),
                helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                externalUrl: "https://www.youtube.com/watch_popup?v=ES15Y5i5vKU",
                externalLabel: this.$t('store.structure.watchTrainingVideoLabel'),
                cancelLabel: this.$t('global.ui.close'),
            },
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            ];
            return state;
        },
        sideButtons() {
            let view = this;

            let state = {
                buttons: [
                    {
                        type: 'block border',
                        icon: 'fa-eye',
                        tooltip: this.$t('store.templates.viewOptions'),
                        click: ($event) => {
                            view.OpenMenuDetails($event, this.displayMenuState);
                        },

                    },
                    
                ]
            };


            return state;
        },
        displayMenuState() {
            const displayItems = [
                {
                    closeOnClick: true,
                    icon: !this.displayInactiveConctractTemplates ? 'fa-toggle-off' : 'fa-toggle-on',
                    text: this.$t('store.templates.displayInactiveConctractTemplates'),
                    click: () => this.$set(this, 'displayInactiveConctractTemplates', !this.displayInactiveConctractTemplates),
                },
                
            ];

            

            return {
                componentref: 'burgermenustate',
                groups: [
                    {
                        label: this.$t('store.templates.viewOptions'),
                        items: displayItems
                    },
                    
                ],
                items: [],
            };
        },
    },
    watch: {
        storeId(newVal, oldVal) {
            console.log("Changed storeId: "+newVal);
            this.refresh();
        }
    }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        overflow-x: hidden;
        top: var(--header-height);
        padding: 0px 14px;
    }
</style>
